(() => {
  const blockSelector = '.frengee-pickup-block[data-frengee-pickup-block]';

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };

  const pickupTiming = (value) => {
    const text = clean(value);
    const match = text.match(/(?:usually\s+)?ready(?:\s+for\s+pickup)?\s+in\s+[^—]+?(?=\s+(?:—|-|or\s+ship)|$)/i);
    if (!match) return text.split(/\s+—\s+/)[0] || 'Pickup timing available at checkout';
    return match[0].replace(/^./, (letter) => letter.toUpperCase());
  };

  const shippingTiming = (summary, available) => {
    const match = clean(summary).match(/ships?(?:\s+to\s+your\s+door)?\s+today/i);
    if (match) return match[0].replace(/^./, (letter) => letter.toUpperCase());
    return available ? 'Ready to ship' : 'Currently unavailable for shipping';
  };

  const addressSummary = (store) => {
    const address = store?.querySelector('.frengee-store__address');
    if (!address) return 'Sparks, Nevada';
    const lines = address.innerText.split(/\n+/).map(clean).filter(Boolean);
    const cityLine = lines.find((line) => /,\s*(Nevada|NV)\b/i.test(line)) || '';
    const city = cityLine.match(/([^,]+),\s*(Nevada|NV)/i);
    return city ? `${clean(city[1])}, Nevada` : 'Sparks, Nevada';
  };

  const optionMarkup = (key, method) => `
    <article class="sierra-pickup-option" data-sierra-pickup-option="${key}" data-state="available">
      <div class="sierra-pickup-option-top">
        <div>
          <span class="sierra-pickup-method">${method}</span>
          <strong class="sierra-pickup-location"></strong>
        </div>
        <span class="sierra-pickup-badge"></span>
      </div>
      <span class="sierra-pickup-status"></span>
      <span class="sierra-pickup-meta"></span>
    </article>`;

  const createPanel = () => {
    const panel = document.createElement('section');
    panel.className = 'sierra-pickup-panel';
    panel.setAttribute('aria-label', 'Pickup and shipping availability');
    panel.innerHTML = `
      <div class="sierra-pickup-header">
        <div>
          <span class="sierra-pickup-eyebrow">Pickup & delivery</span>
          <h3 class="sierra-pickup-title">Choose how you get it</h3>
        </div>
        <span class="sierra-pickup-live">Live availability</span>
      </div>
      <div class="sierra-pickup-options">
        ${optionMarkup('store', 'Store pickup')}
        ${optionMarkup('warehouse', 'Ship from warehouse')}
      </div>`;
    return panel;
  };

  const updateOption = (panel, key, data) => {
    const option = panel.querySelector(`[data-sierra-pickup-option="${key}"]`);
    if (!option) return;
    option.dataset.state = data.state || (data.available ? 'available' : 'unavailable');
    if (data.method) setText(option.querySelector('.sierra-pickup-method'), data.method);
    setText(option.querySelector('.sierra-pickup-location'), data.location);
    setText(option.querySelector('.sierra-pickup-badge'), data.badge);
    setText(option.querySelector('.sierra-pickup-status'), data.status);
    setText(option.querySelector('.sierra-pickup-meta'), data.meta);
  };

  const render = (block) => {
    const pickup = block.querySelector('.frengee-pickup');
    const summaryTitle = clean(block.querySelector('[data-frengee-summary-title]')?.textContent);
    const summarySubtext = clean(block.querySelector('[data-frengee-summary-subtext]')?.textContent);
    if (!pickup || !summaryTitle) return false;

    let panel = pickup.querySelector('.sierra-pickup-panel');
    if (!panel) {
      panel = createPanel();
      pickup.prepend(panel);
    }

    const drawer = document.getElementById(block.dataset.drawerId);
    const store = drawer?.querySelector('.frengee-store--sierra-bicycle-supply');
    const warehouse = drawer?.querySelector('.frengee-store--warehouse');
    const storeName = clean(store?.querySelector('.frengee-store__name')?.textContent) || 'Sierra Bicycle Supply';
    const warehouseName = clean(warehouse?.querySelector('.frengee-store__name')?.textContent) || 'Warehouse';
    const warehouseBadge = clean(warehouse?.querySelector('.frengee-badge')?.textContent);
    const storeAvailable = /pickup available/i.test(summaryTitle)
      && !/unavailable/i.test(summaryTitle);
    const warehouseAvailable = warehouse?.querySelector('.frengee-badge--success') != null
      || /in stock/i.test(warehouseBadge);
    const pickupOnlyRule = [...document.querySelectorAll('.badge.price__badge-sale')]
      .find((element) => /in-store pickup only|shipping unavailable/i.test(clean(element.textContent)));
    const pickupOnly = Boolean(pickupOnlyRule);

    document.querySelectorAll('.sierra-pickup-policy-source').forEach((element) => {
      if (element !== pickupOnlyRule) element.classList.remove('sierra-pickup-policy-source');
    });
    pickupOnlyRule?.classList.add('sierra-pickup-policy-source');
    pickupOnlyRule?.closest('.store-pickup-warning')?.classList.add('sierra-pickup-policy-wrapper');

    panel.dataset.policy = pickupOnly ? 'pickup-only' : 'standard';
    setText(panel.querySelector('.sierra-pickup-eyebrow'), pickupOnly ? 'Pickup policy' : 'Pickup & delivery');
    setText(panel.querySelector('.sierra-pickup-title'), pickupOnly ? 'In-store pickup only' : 'Choose how you get it');
    setText(panel.querySelector('.sierra-pickup-live'), pickupOnly ? 'Pickup-only item' : 'Live availability');

    updateOption(panel, 'store', {
      available: storeAvailable,
      state: storeAvailable ? 'available' : 'unavailable',
      method: 'Store pickup',
      location: storeName,
      badge: storeAvailable ? 'Available' : 'Unavailable',
      status: storeAvailable ? pickupTiming(summarySubtext) : 'Pickup is currently unavailable',
      meta: addressSummary(store)
    });

    updateOption(panel, 'warehouse', {
      available: pickupOnly ? false : warehouseAvailable,
      state: pickupOnly ? 'restricted' : (warehouseAvailable ? 'available' : 'unavailable'),
      method: pickupOnly ? 'Shipping' : 'Ship from warehouse',
      location: pickupOnly ? 'Shipping unavailable' : warehouseName,
      badge: pickupOnly ? 'Pickup only' : (warehouseAvailable ? (warehouseBadge || 'In stock') : 'Unavailable'),
      status: pickupOnly ? 'This item cannot be shipped' : shippingTiming(summarySubtext, warehouseAvailable),
      meta: pickupOnly ? `Collect at ${storeName}` : (warehouseAvailable ? 'Direct fulfillment' : 'Check back soon')
    });

    block.classList.add('sierra-pickup-ready');
    return true;
  };

  const observeBlock = (block) => {
    if (block.dataset.sierraPickupObserved === 'true') return;
    block.dataset.sierraPickupObserved = 'true';

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        render(block);
      });
    };

    const blockObserver = new MutationObserver(schedule);
    blockObserver.observe(block, { childList: true, subtree: true, characterData: true });

    const drawer = document.getElementById(block.dataset.drawerId);
    if (drawer) {
      const drawerObserver = new MutationObserver(schedule);
      drawerObserver.observe(drawer, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    schedule();
  };

  const initialize = () => {
    document.querySelectorAll(blockSelector).forEach(observeBlock);
  };

  initialize();
  const documentObserver = new MutationObserver(initialize);
  const productRoot = document.querySelector('.thb-product-detail') || document.documentElement;
  documentObserver.observe(productRoot, { childList: true, subtree: true });
})();
